module.exports = __webpack_public_path__ + "static/media/webIconLight.2965f0f4.svg";